/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {BrickSnake2000} from "../BrickSnake2000";
import {BrickSnake2000GameAssets} from "../BrickSnake2000GameAssets";
import {gsap} from "gsap";

export class BrickSnake2000ForegroundElements extends PIXI.Container implements StageLayer {
    private logo:PIXI.Sprite;
    private gameIntro:PIXI.spine.Spine;
    private gameIntroTimeline:gsap.core.Timeline;


    constructor() {
        super();
        this.name = "BrickSnake2000ForegroundElements";
        this.init();
    }

    private init() {
        this.logo = new PIXI.Sprite(ImgLoader.getImgTexture(BrickSnake2000GameAssets.IMAGES_LOGO));
        this.logo.scale.set(0.65,0.65);
        this.logo.anchor.set(0.5,0.5);
        this.logo.visible = true;
        this.addChild(this.logo);

        this.gameIntro = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.GAME_INTRO));
        this.gameIntro.position.set(360,360);
        this.gameIntro.visible = false;
        this.gameIntro.name = "GameIntroLol";
        this.gameIntroTimeline = gsap.timeline();
        this.addChild(this.gameIntro);


        this.onOrientationChanged();
        this.onResize();
    }

    public onOrientationChanged() {

    }

    public onResize() {
        if (NolimitApplication.isLandscape){
            this.logo.scale.set(0.65, 0.65);
            this.logo.position.set((NolimitApplication.screenBounds.left - 30) / 2, 130);
            this.logo.visible = -(NolimitApplication.screenBounds.left - 30) > (this.logo.width);
        } else {
            this.logo.scale.set(1,1);
            this.logo.position.set(360, (NolimitApplication.screenBounds.top + 88) / 2);
            this.logo.visible = -(NolimitApplication.screenBounds.top - 88) > (this.logo.height);
        }
    }

    public showGameIntro(): gsap.core.Timeline {
        this.gameIntroTimeline =  gsap.timeline()
            .add(() => {
                this.gameIntro.visible = true;
                this.gameIntro.state.setAnimation(0, `Intro_${Math.floor(Math.random() * 4) + 1}`, true)
            })
            .add(gsap.to(this.gameIntro, {alpha: 1, duration:0.1}), '<')
            .add(gsap.to(this.gameIntro, {alpha: 0, duration:0.1}), '>4.3')
            .add(() => {
                this.gameIntro.visible = false;
                this.gameIntro.state.setEmptyAnimation(0,0);
            })
            .addLabel("end");
        return this.gameIntroTimeline;
    }

    public killGameIntro(): gsap.core.Timeline {
        return this.gameIntroTimeline.seek("end", false);
    }
}